import React from 'react';
import { motion } from 'framer-motion';
import { TypeAnimation } from 'react-type-animation';
import { Link } from 'react-scroll';
import { FiGithub, FiMail, FiArrowDown, FiDownload } from 'react-icons/fi';
import { FaLinkedinIn } from 'react-icons/fa';
import ScrollGrid from './ScrollGrid';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <ScrollGrid fadeVariant="fade-top-right" />

      <div className="hero-container container">
        <div className="hero-content">
          <motion.div
            className="hero-status-bar"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="status-indicator">
              <span className="status-dot" />
              <span>Available for new opportunities</span>
            </div>
            
          </motion.div>

          <motion.h1
            className="hero-headline"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
          >
            <span className="headline-sub">SPECIALIZING IN <span className="gradient-text">WEB</span></span>
            <span className="hero-big-text">
              <span className="hero-big-solid">DEV</span>
              <span className="hero-big-outline">ELO</span>
              <span className="hero-big-accent">PER</span>
            </span>
          </motion.h1>

          <motion.p
            className="hero-description"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.35 }}
          >
            I engineer polished user interfaces with a focus on responsiveness, 
            accessibility, and seamless user journeys. Creative UI/UX Designer and 
            Developer from the Philippines.
          </motion.p>

          <motion.div
            className="hero-typing-row"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <span className="typing-prefix">&gt;_</span>
            <TypeAnimation
              sequence={[
                'Front-End Development',
                2000,
                'UI/UX Design',
                2000,
                'React Applications',
                2000,
                'Responsive Web Apps',
                2000,
              ]}
              wrapper="span"
              speed={50}
              className="typing-output"
              repeat={Infinity}
            />
          </motion.div>

          <motion.div
            className="hero-actions"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <Link to="projects" smooth={true} duration={500} offset={-80}>
              <button className="btn-primary clickable">
                SEE MY WORKS
                <FiArrowDown />
              </button>
            </Link>
            <a href="/Merilo, Jay Marc C.pdf" download>
              <button className="btn-outline clickable">
                <FiDownload />
                DOWNLOAD CV
              </button>
            </a>
          </motion.div>

          <motion.div
            className="hero-socials"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.7 }}
          >
            <a
              href="https://github.com/emarcj0-debug"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link clickable"
              aria-label="GitHub"
            >
              <FiGithub />
            </a>
            <a
              href="mailto:jaymarccmerilo@gmail.com"
              className="social-link clickable"
              aria-label="Email"
            >
              <FiMail />
            </a>
            <a
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link clickable"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
      >
        <Link to="about" smooth={true} duration={500} offset={-80} className="clickable">
          <span className="scroll-label">SCROLL</span>
          <div className="scroll-line">
            <div className="scroll-line-fill" />
          </div>
        </Link>
      </motion.div>
    </section>
  );
};

export default Hero;
